import React from 'react';
import AutoComplete from 'material-ui/AutoComplete';

export default class AutoCompleteHOC extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchText: props.searchText,
        };

        this.handleNewRequest = this.handleNewRequest.bind(this);
        this.handleUpdateInput = this.handleUpdateInput.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.searchText !== nextProps.searchText) {
            this.setState({
                searchText: nextProps.searchText || ''
            });
        }
    }

    handleUpdateInput = (searchText) => {
        this.setState({
            searchText: searchText,
        }, () => {
            this.props.onUpdateInput(searchText);
        });
   };

    handleNewRequest = (chosenRequest, index) => {
        const {dataSourceConfig: {text}} = this.props;

        if (index === -1) {
            return;
        }

        this.setState({
            searchText: chosenRequest[text],
        });

        this.props.onNewRequest(chosenRequest, index);
    };

    render () {
        return <AutoComplete
            {...this.props}
            searchText={this.state.searchText}
            onNewRequest={this.handleNewRequest}
            onUpdateInput={this.handleUpdateInput}
        />
    }

}


// WEBPACK FOOTER //
// ./app/components/Domains/AutoCompleteHOC.jsx